import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ApiKeysService, ScrollContainerService } from '../../core/services';

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainScroll', { static: true }) mainScrollRef!: ElementRef<HTMLElement>;
  @ViewChild('menuButton', { static: true }) menuButtonRef!: ElementRef<HTMLButtonElement>;

  /** Phone-width only: the sidebar slides in as a drawer over the page.
   *  On desktop the sidebar is always shown and this stays false. */
  navOpen = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private apiKeysService: ApiKeysService,
    private scrollContainer: ScrollContainerService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.apiKeysService.getActiveApiKeys().subscribe();
    // Picking a link in the drawer should land on the page, not leave the
    // drawer covering it.
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      takeUntil(this._destroy$),
    ).subscribe(() => (this.navOpen = false));
  }

  ngAfterViewInit(): void {
    this.scrollContainer.element = this.mainScrollRef.nativeElement;
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  openNav(): void {
    this.navOpen = true;
  }

  closeNav(): void {
    if (!this.navOpen) return;
    this.navOpen = false;
    this.menuButtonRef.nativeElement.focus();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeNav();
  }
}
